import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';

const Address1Input = (props) => {
  return(
    <Form.Item
      validateStatus={
        props.errors && props.errors.Address1 && props.touched.Address1
          ? "error"
          : null
      }
      help={props.errors && props.touched.Address1 && props.errors.Address1}
    >
      <h2 className="form-label">
        Address line 1
      </h2>
      <Input 
        type="text" 
        id="Address1" 
        className="form-input"
        value={props.values.Address1} 
        onChange={props.onChange}
      />
    </Form.Item>
  );
}

Address1Input.propTypes = {
    onChange: () => {},
    errors: PropTypes.shape({
        Address1: PropTypes.string,
    }),
    values: PropTypes.shape({
        Address1: PropTypes.string,
    }),
    touched: PropTypes.shape({
        Address1: PropTypes.bool,
    })
}

Address1Input.defaultProps = {
    onChange: () => {},
    errors: {},
    values: {},
    touched: {}
}

export default Address1Input;
